export const technologies = ['React', 'Redux', 'Express', 'Knex', 'Jest','Node.Js', 'PostgreSQL', 'MongoDB' ,'Docker'];
export const languages = ['Python', 'JavaScript', 'HTML', 'CSS', 'SQL'];